import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@app/store/auth.store';
import { canAll, canAny, getDefaultAdminRoute, isSuperAdmin } from '../roles';

interface RequirePermissionProps {
  /** Pass if any one permission is enough. */
  anyOf?: string[];
  /** Pass if every permission is required. */
  allOf?: string[];
  children: ReactNode;
  redirectTo?: string;
}

/**
 * Route-level permission gate. Super admins always pass.
 * Prefer this over RequireRole (kept as a thin legacy wrapper).
 */
export function RequirePermission({
  anyOf,
  allOf,
  children,
  redirectTo,
}: RequirePermissionProps) {
  const user = useAuthStore((s) => s.user);
  if (isSuperAdmin(user)) return <>{children}</>;

  let ok = false;
  if (anyOf && anyOf.length > 0) ok = canAny(user, anyOf);
  else if (allOf && allOf.length > 0) ok = canAll(user, allOf);
  else ok = !!user;

  if (!ok) {
    return <Navigate to={redirectTo ?? getDefaultAdminRoute(user)} replace />;
  }
  return <>{children}</>;
}
